module.exports = {
frame:{
    top_position: {
        y: 0,
        x: 0
    },
    right_position: {
        y: 13,
        x: 177
    },
    bottom_position: {
        y: 177,
        x: 0
    },
    left_position: {
        y: 13,
        x: 0
    }
}
};



//////////////////
// WEBPACK FOOTER
// ./cfg/frames-config.js
// module id = 23
// module chunks = 0